<div class="row g-3">
  <div class="col-md-12">
    <app-metric-card
      class="coverage-card"
      [title]="'Coverage'"
      [currentValue]="emailCoverage()?.current_coverage_percentage ?? 0"
      [hideComparison]="true"
      [hidePrevious]="true"
      [suffix]="'%'"
      [showLeftBorder]="true"
      [showLastUpdated]="true"
      [lastUpdatedDate]="emailCoverage()?.last_updated ?? null"
      [lastUpdatedLabel]="'Last updated:'"
    ></app-metric-card>
  </div>
</div>
